import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import { useSnackbarContext } from 'Context/SnackbarContext';
import Content from './Content';

const HouseholdNextActionContainer = ({ relationshipLink }) => {
  const { displayErrorMessage } = useSnackbarContext();

  const {
    isInitializing,
    collection,
  } = useLink(
    relationshipLink,
    { onError: (e) => displayErrorMessage(e, (e.errors && e.errors[0]?.detail) || 'There was a problem loading the dashboard.') },
  );

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      componentProps={{
        resource: collection?.resources().head(),
      }}
    />
  );
};

HouseholdNextActionContainer.defaultProps = {
};

HouseholdNextActionContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default HouseholdNextActionContainer;
